import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import ContractorContact from '../../types/api/contractor-contact'
import getQuery from '../../helpers/api/get-query'

export const contractorContactsApi = createApi({
    reducerPath: 'contractorContactsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['ContractorContacts'],
    endpoints: builder => ({
        getContractorContacts: builder.query<Strapi<ContractorContact>, EndpointQueryParameters | void>({
            query: getQuery('/contractor-contacts'),
            providesTags: ['ContractorContacts'],
        }),
        createContractorContact: builder.mutation<
            StrapiSingle<ContractorContact>,
            StrapiCreate<ContractorContact>
        >({
            query: body => ({
                url: '/contractor-contacts',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ContractorContacts'],
        }),
        updateContractorContact: builder.mutation<
            StrapiSingle<ContractorContact>,
            StrapiUpdate<ContractorContact>
        >({
            query: ({ docId, body }) => ({
                url: `/contractor-contacts/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['ContractorContacts'],
        }),
    }),
})

export const {
    useGetContractorContactsQuery,
    useCreateContractorContactMutation,
    useUpdateContractorContactMutation,
} = contractorContactsApi